import { formatDate } from '@sparkpost/report-builder/helpers/date';
import React from 'react';
import { ExternalLink, SubduedLink } from 'src/components/links';
import { Column, Columns, LabelValue, Layout, Panel, Stack } from 'src/components/matchbox';
import { SubduedText } from 'src/components/text';
import { EXTERNAL_LINKS } from '../constants';
import TlsStatusBadge from './TlsStatusBadge';

function isRenewalDateInFuture(tlsCertificate) {
  if (!tlsCertificate?.expires_at) {
    return false;
  }
  return new Date() < new Date(tlsCertificate.expires_at);
}

export default function TrackingDomainTLSCertificateSection({ domain, isSectionVisible }) {
  if (!isSectionVisible) {
    return null;
  }

  const {
    uses_managed_certificate: usesManagedCertificate,
    status,
    tls_certificate: tlsCertificate,
    verified
  } = domain;

  if (!usesManagedCertificate) {
    return null;
  }

  const tlsStatusValid = status?.tls_status === 'valid';
  const showRenewalDate = isRenewalDateInFuture(tlsCertificate);

  return (
    <Layout>
      <Layout.Section annotated>
        <Layout.SectionTitle as="h2">TLS certificate</Layout.SectionTitle>
        <Stack>
          <SubduedText fontSize="200">
            SparkPost automatically manages a TLS certificate for this tracking domain, enabling
            secure connections for click and open tracking.
          </SubduedText>
          <SubduedLink
            as={ExternalLink}
            to={EXTERNAL_LINKS.TRACKING_DOMAIN_DOCUMENTATION}
            fontSize="200"
          >
            Tracking Domain Documentation
          </SubduedLink>
        </Stack>
      </Layout.Section>
      <Layout.Section>
        <Panel>
          <Panel.Section>
            <Columns>
              <Column>
                <LabelValue>
                  <LabelValue.Label>Certificate Status</LabelValue.Label>
                  <LabelValue.Value>
                    <TlsStatusBadge
                      tlsStatus={status?.tls_status}
                      tlsCertificate={tlsCertificate}
                      verified={verified}
                    />
                  </LabelValue.Value>
                </LabelValue>
              </Column>
              {tlsStatusValid && tlsCertificate?.issued_at && (
                <Column>
                  <LabelValue>
                    <LabelValue.Label>Issued At</LabelValue.Label>
                    <LabelValue.Value>
                      {formatDate.useMomentInput(tlsCertificate.issued_at)}
                    </LabelValue.Value>
                  </LabelValue>
                </Column>
              )}
              {tlsStatusValid && showRenewalDate && (
                <Column>
                  <LabelValue>
                    <LabelValue.Label>Next Renewal</LabelValue.Label>
                    <LabelValue.Value>
                      {formatDate.useMomentInput(tlsCertificate.expires_at)}
                    </LabelValue.Value>
                  </LabelValue>
                </Column>
              )}
            </Columns>
          </Panel.Section>
        </Panel>
      </Layout.Section>
    </Layout>
  );
}
